// extracted by mini-css-extract-plugin
export default {"label":"Filter_label__vEd1E","input":"Filter_input__N7T3z","text":"Filter_text__uqQRu"};